import {FC} from "react";
import styled from "styled-components";
import {useSelector} from "react-redux";
import {useTranslation} from "react-i18next";
import {useLocation} from "react-router-dom";
import {isLoggedIn} from "modules/selectors";
import {getUri} from "modules/utils";
import {Exist, PrimaryExternalLink, SecondaryExternalLink} from "components";

const ButtonsContainer = styled.div`
	display: flex;
	gap: 20px;
	width: 100%;

	a {
		border-radius: 4px;
	}

	${({theme}) => theme.breakpoints.up("mobile")} {
		max-width: 335px;
	}
`;

export const NonLoggedUserButtons: FC = () => {
	const {t} = useTranslation();
	const location = useLocation();
	const isLogged = useSelector(isLoggedIn);

	return (
		<Exist when={!isLogged}>
			<ButtonsContainer>
				<PrimaryExternalLink target="_self" href={getUri("login", location.pathname)}>
					{t("main.button.login")}
				</PrimaryExternalLink>

				<SecondaryExternalLink
					target="_self"
					href={getUri("registration", location.pathname)}>
					{t("main.button.register")}
				</SecondaryExternalLink>
			</ButtonsContainer>
		</Exist>
	);
};
